import { dia } from "@clientio/rappid";
import { CircularPort } from "../../ports";
import { ShapeAttributes, TWITTER_ICON } from "../../theme";

export default class Diamond extends dia.Element {
  defaults(): Partial<dia.Element.Attributes> {
    return {
      ...super.defaults,
      type: "app.Diamond",
      size: { width: ShapeAttributes.width, height: ShapeAttributes.height },
      attrs: {
        body: {
          points: "0,24 24,0 48,24 24,48",
          strokeWidth: ShapeAttributes.strokeWidth,
          stroke: ShapeAttributes.stroke,
          fill: ShapeAttributes.fill,
        },
        icon: {
          width: ShapeAttributes.icon.width,
          height: ShapeAttributes.icon.height,
          refX: ShapeAttributes.icon.refX,
          refY: ShapeAttributes.icon.refY,
          x: ShapeAttributes.icon.x,
          y: ShapeAttributes.icon.y,
          xlinkHref: TWITTER_ICON,
        },
      },
      markup: [
        {
          tagName: "polygon",
          selector: "body",
        },
        {
          tagName: "image",
          selector: "icon",
        },
      ],
      ports: {
        groups: {
          in: CircularPort("left", ShapeAttributes.port.in),
          error: CircularPort("bottom", ShapeAttributes.port.error),
          out: CircularPort("right", ShapeAttributes.port.out),
        },
        items: [{ group: "in" }, { group: "error" }, { group: "out" }],
      },
    };
  }
}
